<template>
  <div>
    <v-list v-if="selectedItem" class="pt-1 pb-1">
      <v-list-item class="px-0">
          <v-list-item-avatar
            class="ma-0 border-radius-4 mr-4 d-flex align-center justify-center"
            :class="this.isDarkTheme ? 'dark-border' : 'light-border'"
            tile
            size="64"
            :color="getColor(selectedItem['online_status'])"
            v-if="type === 'location' || route === 'locations'"
        ><span v-if="selectedItem.name" class="white--text headline" style="display: flex; align-items: center; justify-content: center; width: 100%; height: 100%;">{{ avatarName(selectedItem.name).toUpperCase() }}</span>
        </v-list-item-avatar>
        <v-list-item-avatar
            class="ma-0 border-radius-4 mr-4"
            tile
            size="64"
            v-else-if="type === 'device'  || type === 'camera'"
        >
          <div
              v-bind:class="[
              selectedItem.connected_status ==='connected' && selectedItem.online === true ? 'online_device': 
              selectedItem.connected_status ==='connected' && selectedItem.online === false ? 'offline_device': 
              selectedItem.connected_status === 'non_connected' ? 'non_connected':
              selectedItem.connected_status ==='disconnected' || 
              selectedItem.connected_status === 'archived' || 
              selectedItem.connected_status ==='installation_pending' ? 'offline': 'uninstalled_device',
              'item-icon',
              'device-icon',
              this.isDarkTheme ? 'dark-border' : 'light-border'
              ]"
          >
            <v-icon
                size="24"
                v-bind:class="selectedItem.connected_status === 'connected' && selectedItem.online === true ? 'connected_icon' :
                selectedItem.connected_status === 'connected' && selectedItem.online === false ? 'offline_device_icon' :
                selectedItem.connected_status === 'disconnected' || 
                selectedItem.connected_status === 'archived' ||
                selectedItem.connected_status === 'installation_pending' ? 'disconnected_icon' :  
                selectedItem.connected_status === 'non_connected' ? 'non_connected_icon': null"
            >{{ icons[selectedItem["device_type_name"]] }}
            </v-icon>
          </div>
        </v-list-item-avatar>
        <v-list-item-avatar
            size="64"
            tile
            class="ma-0 border-radius-4 mr-4 d-flex align-center justify-center"
            v-else-if="type === 'group' || (route ==='groups' && selectedItem.name !== 'Add Location Group')"
            :class="[
              selectedItem.active ? 'active_group' : 'unactive_group',
              'item-icon', this.isDarkTheme ? 'dark-border' : 'light-border'
            ]">
          <v-icon size="24" :color="groupIconColor">
            {{ icons.mdiMapMarkerMultiple }}
          </v-icon>
        </v-list-item-avatar>
        <v-list-item-content>
          <v-list-item-title
              class="float-right headline font-weight-bold text-primary"
          >
          <v-list-item-content v-if="selectedItem.demo_mode">
            <v-chip
                class="demo-chip"
                color="#FFC107" 
                text-color="black"
                small
              >
                Demo Mode
              </v-chip>

          </v-list-item-content>
          
            <span v-if="type === 'edit'">Edit</span>
            {{ selectedItem.name }}
            <!--Need to keep in mind using v-show vs v-if-->
            <span>
              <v-icon v-if="type === 'device'" 
              size="10" 
              class="text-primary" 
              :color="selectedDevice.online ? 'green' : 'red'">
              {{ $vuetify.icons.values.circle }}
            </v-icon>
          </span>
          </v-list-item-title>
          <v-list-item-subtitle
              v-if="selectedItem.subtitle"
              class="text-secondary">
            {{ selectedItem.subtitle }}
          </v-list-item-subtitle>
        </v-list-item-content>
        <v-list-item-action>
          <v-col class="pa-0">
            <v-menu offset-y v-if="type">
              <template v-slot:activator="{ on }">
                <v-btn v-if="!['edit', 'reset'].includes(type)" class="mr-2" icon v-on="on" plain>
                  <v-icon class="text-primary">{{ $vuetify.icons.values.dotsVertical }}</v-icon>
                </v-btn>
              </template>
              <v-list dense width="224px">
                <v-list-item
                    v-for="(item, i) in showActionItems"
                    :key="i"
                    class="v-list-hover"
                    @click="openModal(item)"
                >
                  <v-list-item-icon class="pr-0 mr-4">
                    <v-icon class="text-secondary">{{ item.icon }}</v-icon>
                  </v-list-item-icon>
                  <v-list-item-title class="pr-4 font-weight-regular text-primary">
                    {{ item.title }}
                  </v-list-item-title>
                </v-list-item>
              </v-list>
            </v-menu>
            <v-btn @click="closeDialog()" plain icon>
              <v-icon class="text-primary">{{ $vuetify.icons.values.close }}</v-icon>
            </v-btn>
          </v-col>
        </v-list-item-action>
      </v-list-item>
    </v-list>

    <ConfirmationDialog
      :show="confirm.show"
      :title="confirm.title"
      :message="confirm.message"
      :confirmText="confirm.confirmText"
      :icons="icons"
      @close="handleCancel"
      @cancel="handleCancel"
      @confirm="handleConfirm"
    />

    <!-- Delete Confirmation Dialog -->
    <v-dialog v-model="deleteDialog.show" max-width="400px">
      <v-card>
        <v-card-title class="headline">{{ deleteDialog.title }}</v-card-title>
        <v-card-text>{{ deleteDialog.message }}</v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="grey" text @click="cancelDelete">Cancel</v-btn>
          <v-btn color="error" text @click="confirmDelete">Delete</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import {mapActions, mapGetters} from "vuex";
import {mdiTelevision, mdiArchive, mdiCctv, mdiClose, mdiContentCopy, mdiDelete, mdiLaptop, mdiPencil, mdiRaspberryPi, mdiDevices, mdiMapMarkerMultiple,  mdiRotateLeft} from "@mdi/js";
import ConfirmationDialog from "./Devices/Device/ConfirmationDialog.vue";

export default {
  name: "FlyoutMenuHead",
  props: ["selectedItem", "type", "route", "channel"],
  components: {
    ConfirmationDialog,
  },
  data() {
    return {
      route_name: null,
      icons: {
        'Linux Computer': mdiLaptop,
        "Windows Computer": mdiLaptop,
        'camera': mdiCctv,
        'RaspberryPi': mdiRaspberryPi,
        'Unknown': mdiDevices,
        'mdiMapMarkerMultiple': mdiMapMarkerMultiple,
        'Android TV': mdiTelevision,
        mdiClose: mdiClose,
      },
      confirm: {
        show: false,
        title: '',
        message: '',
        confirmText: 'Confirm',
        onConfirm: null,
      },
      actionItems: [
        {
          title: "Edit",
          icon: mdiPencil,
        },
        {
          title: "Delete",
          icon: mdiDelete,
        },
        {
          title: "Archive",
          icon: mdiArchive,
        },
        {
          title: "Copy Device URL",
          icon: mdiContentCopy,
          message: "Device URL copied to clipboard",
          action: this.getUrl()
        },
        {
          title: "Unarchive",
          icon: mdiArchive,
        },
        {
          title: "Reset Credentials",
          icon: mdiRotateLeft,
        }
        
        
      
      ],
      modals: {
        "device-delete": false,
        "device-archive": false,
      },
      data: {
        editDevice: true,
        editLocation: true,
        editGroup: true,
        deleteDevice: true,
        deleteLocation: true, 
        deleteGroup: true     
      },
      deleteDialog: {
        show: false,
        title: '',
        message: '',
        type: '', // 'operator' or 'operator_group'
        item: null
      }
    };
  },
  computed: {
    ...mapGetters({selectDevice: "devices/getSelectedDevice"}),
    selectedDevice() {
      return this.selectDevice;
    },
    showActionItems() {
      let filteredItems = this.actionItems;
      if (this.$route.name === 'resetOperatorCredentials') return [];
      // Hide "Delete" if total_number is greater than 0
      if (this.selectedItem.total_number > 0) {
        filteredItems = filteredItems.filter(item => item.title !== 'Delete');
      }
      
      // Handle operator type - only show Edit, Reset Credentials, and Delete
      if (this.type === 'operator') {
        return filteredItems.filter(item => ['Edit', 'Reset Credentials'].includes(item.title));
      } 
      
      // Handle operator_group type - only show Edit (no Delete)
      if (this.type === 'operator_group') {
        return filteredItems.filter(item => item.title === 'Edit');
      }
      
      // For non-operators, exclude Reset Credentials
      filteredItems = filteredItems.filter(item => item.title !== 'Reset Credentials');
      
      // Filter based on the connected_status for devices
      if (this.selectedItem['connected_status'] === 'disconnected') {
        return filteredItems.filter(item => item.title !== 'Unarchive' && item.title !== 'Copy Device URL' && item.title !== "Delete");
      } else if (this.selectedItem['connected_status'] === 'connected') {
        return filteredItems.filter(item => item.title !== 'Unarchive' && item.title !== 'Copy Device URL' && item.title !== 'Delete');
      }else if (this.selectedItem['connected_status'] === 'installation_pending') {
        return filteredItems.filter(item => item.title !== 'Unarchive' && item.title !== 'Copy Device URL' && item.title !== 'Delete');
      } else if (this.selectedItem['connected_status'] === 'non_connected') {
        return filteredItems.filter(item => item.title !== 'Archive' && item.title !== 'Copy Device URL' && item.title !== 'Unarchive');
      } else if (this.selectedItem['connected_status'] === 'archived') {
        return filteredItems.filter(item => item.title !== 'Archive' && item.title !== 'Copy Device URL' && item.title !== "Delete");
      } else if (this.type === 'location') {
        return filteredItems.filter(item => item.title !== 'Copy Device URL' && item.title !== 'Archive' && item.title !== 'Unarchive');
      } else {
        return filteredItems.filter(item => item.title !== 'Copy Device URL' && item.title !== 'Archive' && item.title !== 'Unarchive');
      }
    },
    isDarkTheme() {
      return this.$vuetify.theme.dark || false;
    },
    groupIconColor() {
      return this.selectedItem.active ? 'white' : 'gray';
    },
  },
  methods: {
    ...mapActions("devices", ["setDeviceFlyout", "deleteDevice", "getDevices"]),
    ...mapActions("locations", ["setLocationFlyout", "deleteLocation"]),
    ...mapActions("groups", ["deleteGroup"]),
    ...mapActions("operators", ["deleteOperator", "deleteOperatorGroup"]),
    openModal(type) {
      if ((this.route === 'devices' && type.title === 'Edit')  || 
          (this.route === "locations" && type.title === "Edit") || 
          (this.route === "performance" && type.title === "Edit") ||
          (this.route === "activity" && type.title === "Edit") ||
          (this.route === "group" && type.title === "Edit")
        ) {
        let newRoute = this.$route;
        newRoute.params.action = "edit";
        this.$router.push(newRoute);
        // if (this.type === 'device' || this.type === 'camera') {
        //   this.setDeviceFlyout(this.data);
        // } else if (this.type === 'location') {
        //   this.setLocationFlyout(this.data);
        // }
      } else if (this.type === 'device' && type.title === "Delete") {
        this.deleteDevice(this.$props.selectedItem);
        this.$router.push('/devices');
      }else if(this.type === 'device' && type.title === "Archive"){
        this.openArchiveConfirm();
      }else if(this.type === 'device' && type.title === "Unarchive"){
        this.$store.dispatch('devices/unarchiveDevice', this.$props.selectedItem).then(() => {
          this.getDevices();
        });
        this.$router.push('/devices');
      }else if(this.type === 'location' && type.title === "Delete"){
         this.deleteLocation(this.$props.selectedItem);
         this.$router.push('/locations');
      }else if(this.type === 'group' && type.title === "Delete"){
         this.deleteGroup(this.$props.selectedItem.uuid);
         this.$router.push('/groups');
      }else if(this.type === 'operator' && type.title === "Delete"){
         this.showDeleteDialog('operator');
      }else if(this.type === 'operator_group' && type.title === "Delete"){
         this.showDeleteDialog('operator_group');
      }else if(this.type === 'operator' && type.title === "Edit"){
         // Open edit flyout for operator
         this.$router.push(`/operators/${this.$props.selectedItem.uuid}/edit`);
      }else if(this.type === 'operator' && type.title === "Reset Credentials"){
         // Open reset credentials flyout for operator
         this.$router.push(`/operators/${this.$props.selectedItem.uuid}/reset`);
      }else if(this.type === 'operator_group' && type.title === "Edit"){
         // Open edit flyout for operator group  
         this.$router.push(`/operator-groups/${this.$props.selectedItem.uuid}/edit`);
      }
      else if(this.$props.route === 'device_location' && type.title === "Copy device URL" && this.type === 'device'){
         this.getUrl();  
      }
    },

    closeDialog() {
      if(this.$route.name === 'location' && this.$route.params.action === 'view'){
          this.$router.replace(`/locations`)
             if (localStorage.getItem("fromGroups")) {
              let nameFrom = localStorage.getItem('fromGroups');
              this.$router.replace(nameFrom);
              return;
            }
          }
      if(this.$route.name === 'device_location' && window.history.length === 2){
        this.$router.replace(`/locations`)
      }else if(this.$route.name === 'editOperator'){
        window.history.length > 1 ? this.$router.go(-1) : this.$router.replace(`/${this.$route.name}s`);
      }else if(this.$route.name === 'editOperatorGroup'){
        window.history.length > 1 ? this.$router.go(-1) : this.$router.replace(`/${this.$route.name}s`);
      }else if(this.$route.name === 'resetOperatorCredentials'){
        window.history.length > 1 ? this.$router.go(-1) : this.$router.replace('/operators');
      }

      if (
         this.$route.name === 'location' 
      || this.$route.name === 'device' 
      || this.$route.name === 'account' 
      || this.$route.name === 'device_location' 
      || this.$route.name === 'performance' 
      || this.$route.name === 'activity' 
      || this.$route.name === 'activity_device' 
      || this.$route.name === 'performance_device' 
      || this.route_name === "group"
      
    ) {
        if (this.$route.params.fromLocation) {
          this.$router.replace(`/devices`)
        }
        else if(this.route === 'group'){
          this.$router.replace(`/groups`)
          this.$store.commit("groups/setGroup", '');
        }
        else if(this.$route.params.action === 'detectDevices'){
          this.$store.commit('locations/SET_DETECTED_DEVICES', []);
          this.$store.commit("devices/SET_NO_DETECT_DEVICES", false);
        } else {
          if (window.history.length > 2) {
            if((['general', 'peripherals', 'assetInfo', 'settings'].includes(this.$route.params.tab) && this.$route.name !== "device" && this.$route.params.action !== "edit")){
               if(this.$route.name === 'device_location'){
                this.$router.replace(`/locations/location/view/${this.selectedItem.location_uuid}/${this.$route.params.tab}`)
              }else if(this.$route.name === 'activity_device'){
                this.$router.replace(`/activity`)
              }else if(this.$route.name === 'performance_device'){
                this.$router.replace(`/performance`)
              }else{
                 this.$router.replace(`/${this.$route.name}`)
              }
            }if((['general', 'peripherals', 'assetInfo', 'settings'].includes(this.$route.params.tab) && this.$route.name === "device" && this.$route.params.action !== "edit")){
              this.$router.replace(`/${this.$route.name}s`)
            }else if(this.$route.params.action === "edit"){
              this.$router.go(-1);
            }
            this.$store.commit('monitoring/SET_SELECTED_DEVICE', "");
          }else if(this.$route.name === 'device_location'){
            this.$router.replace(`/locations/location/view/${this.selectedItem.location_uuid}/devices`)
          } 
          else {
             if(this.$route.params.actions === 'edit' && this.$route.name === 'group'){
              this.$router.replace(`/${this.$route.name}`);
            }else if(this.$route.name === 'activity_device'){
              this.$router.replace(`/activity`);
            }else if(this.$route.name === 'performance_device'){
              this.$router.replace(`/performance`);
            }else{
              this.$router.replace(`/${this.$route.name}s`);
            }
          }
        }
        this.$store.commit('devices/SET_SELECTED_DEVICE', "");
        this.$store.commit('devices/SET_ACTIVE_PERIPHERAL', "");
        this.$store.commit('monitoring/SET_SELECTED_DEVICE', "");
      }
      if (this.$route.name === 'accounts_action' || 
          this.$route.name === 'location_action' || 
          this.$route.name === 'device_action'   || 
          this.$route.name === 'devices_action'  || 
          this.$route.name === 'group_action'    || 
          this.$route.name === 'operator_action' || 
          this.$route.name === 'addOperator' ||
          this.$route.name === 'addOperatorGroup' ||
          this.$route.name === 'viewOperator' ||
          this.$route.name === 'viewOperatorGroup'
      ) {
        // For operator routes, navigate to the appropriate list page
        if (this.$route.name === 'addOperator' || this.$route.name === 'viewOperator') {
          this.$router.push('/operators');
        } else if (this.$route.name === 'addOperatorGroup' || this.$route.name === 'viewOperatorGroup') {
          this.$router.push('/operator-groups');
        } else if (this.$route.name === 'devices_action') {
          // Clean up detect devices state if needed
          this.$store.commit('locations/SET_DETECTED_DEVICES', []);
          this.$store.commit("devices/SET_NO_DETECT_DEVICES", false);
          this.$router.push('/devices');
        } else if (window.history.length > 0) {
          this.$router.go(-1);
        } 
      }

      this.$store.commit('devices/SET_SELECTED_DEVICE', "");
      this.$store.commit('monitoring/SET_SELECTED_DEVICE', "");
      this.$store.commit("devices/SET_LOADER_SCREENSHOT", false);      
      this.$store.commit("devices/SET_LOADER_RD", false);      
      this.$store.commit("devices/SET_LOADER_RSSH", false);
      this.$store.commit("devices/SET_LOADER_CONFTOOL", false);
      this.$store.commit("devices/SET_LOADER_TOUCHSCREENCALIBRATION", false);
      this.$store.commit("locations/SET_LOCATION_DEVICES", []);
      this.$store.commit("devices/SET_DEVICE_COMMENTS", {});
      if(this.channel) {
        this.channel.unbind();
        this.channel.unsubscribe();
      }
    },
    getUrl(){
      //let url = window.location.origin;
      //let newUrl =`${url}/devices/device/view/${this.$props.selectedItem.uuid}/general`;
      //navigator.clipboard.writeText(newUrl);
    },
    avatarName(string) {
      var matches = string.match(/\b(\w)/g);
      return matches.join("");
    },
    getColor(type) {
      var colors = {
         "online": "#2B85D8",
        "partially_online": "#3AB0C0",
        "offline": "#7A7A7A",
      };
      return colors[type];
    },
    openArchiveConfirm() {
      const name = this.$props.selectedItem.name || 'this device';
      this.confirm = {
        show: true,
        title: 'Archive',
        message: `Are you sure you want to archive ${name}? This action clears the device cache.`,
        confirmText: 'Confirm',
        onConfirm: () => {
          this.$store.dispatch('devices/archiveDevice', this.$props.selectedItem);
          this.$router.push('/devices');
        }
      };
    },

    handleConfirm() {
      try { this.confirm.onConfirm && this.confirm.onConfirm(); }
      finally { this.confirm.show = false; }
    },

    handleCancel() {
      this.confirm.show = false;
    },

    showDeleteDialog(type) {
      const itemName = this.$props.selectedItem.name || 'this item';
      this.deleteDialog = {
        show: true,
        title: `Delete ${type === 'operator' ? 'Operator' : 'Operator Group'}`,
        message: `Are you sure you want to delete ${type === 'operator' ? 'operator' : 'operator group'} "${itemName}"? ${type === 'operator_group' ? 'This will remove all operators from this group. ' : ''}This action cannot be undone.`,
        type: type,
        item: this.$props.selectedItem
      };
    },

    cancelDelete() {
      this.deleteDialog.show = false;
    },

    async confirmDelete() {
      try {
        if (this.deleteDialog.type === 'operator') {
          await this.deleteOperator(this.deleteDialog.item.uuid);
          this.$router.push('/operators');
        } else if (this.deleteDialog.type === 'operator_group') {
          await this.deleteOperatorGroup(this.deleteDialog.item.uuid);
          this.$router.push('/operator-groups');
        }
        this.deleteDialog.show = false;
      } catch (error) {
        console.error('Error deleting item:', error);
        this.$emit('error', `Failed to delete ${this.deleteDialog.type}: ${error.message || error}`);
        this.deleteDialog.show = false;
      }
    },
  },
  mounted(){
    this.route_name = this.$route.name;
  }
};
</script>

<style scoped>
.demo-chip {
  display: inline-flex !important;
  width: auto !important;
  max-width: 80px !important;
  padding: 0 8px !important;
  height: 20px;
  font-size: 12px;
  font-weight: bold;
  line-height: 24px;
  border-radius: 4px !important;
  font-weight: 500;
}

.device-icon {
  padding: 20px;
  background-color: var(--v-lightGrey-base);
  width: 64px !important;
  height: 64px !important;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 4px !important;
}

.installed {
  background-color: var(--v-blueishGray-base) !important;

}

.offline {
  background-color: #222222 !important;
}
.non_connected {
  background-color: var(--v-nonConnectedBg-base) !important;
}

.connected_icon {
  color: var(--v-general_bckgr-base) !important;
}

.offline_device_icon {
  color: var(--v-offlineDeviceIcon-base) !important;
}

.disconnected_icon {
  color: var(--v-secondaryText-base) !important;
  
}
 .non_connected_icon {
    color: var(--v-nonConnectedIcon-base) !important;
  }
.online {
  background-color: green !important;
}
.offline-icon {
  background-color: red !important;
}
.border-radius-4 {
  border-radius: 4px !important;
}
.online_device{
    background-color: #2b85d8 !important;
    opacity:1;
    border: 1px solid var(--v-deviceIconBorder-base);
  }
  .offline_device{
    background-color: var(--v-offlineDeviceBg-base) !important;
    border: 1px solid var(--v-deviceIconBorder-base);
  }
  .uninstalled_device{
    border: 1px solid var(--v-deviceIconBorder-base);
  }
.dark-border {
  border:1px solid #B6AFAF !important;
}

.light-border {
  border:1px solid #464343 !important;
}
.active_group{
    background-color: #2b85d8 !important;
    opacity: 1;
  }
  .unactive_group{
    background-color: #E0E0E0 !important;
    opacity: 1;
  }
</style>
